module.exports = __webpack_public_path__ + "static/media/gold-chip.cda96a85.svg";